var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComingSoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 34,
    viewBox: "0 0 55 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7441 2C29.4599 2 22.7441 8.71573 22.7441 17C22.7441 25.2843 29.4599 32 37.7441 32C46.0284 32 52.7441 25.2843 52.7441 17C52.7441 8.71573 46.0284 2 37.7441 2ZM20.7441 17C20.7441 7.61116 28.3553 0 37.7441 0C47.133 0 54.7441 7.61116 54.7441 17C54.7441 26.3888 47.133 34 37.7441 34C28.3553 34 20.7441 26.3888 20.7441 17Z",
    fill: "#FF7815"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7441 6.66602C38.2964 6.66602 38.7441 7.11373 38.7441 7.66602V15.9993H47.0775C47.6298 15.9993 48.0775 16.4471 48.0775 16.9993C48.0775 17.5516 47.6298 17.9993 47.0775 17.9993H37.7441C37.1919 17.9993 36.7441 17.5516 36.7441 16.9993V7.66602C36.7441 7.11373 37.1919 6.66602 37.7441 6.66602Z",
    fill: "#FF7815"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4102 13.0762C16.4102 13.6285 15.9624 14.0762 15.4102 14.0762L0.999899 14.0762C0.447614 14.0762 -0.000101089 13.6285 -0.000101089 13.0762C-0.000101089 12.5239 0.447614 12.0762 0.999899 12.0762L15.4102 12.0762C15.9624 12.0762 16.4102 12.5239 16.4102 13.0762Z",
    fill: "#FF7815"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6934 6.51367C19.6934 7.06596 19.2456 7.51367 18.6934 7.51367L10.8472 7.51367C10.2949 7.51367 9.84721 7.06596 9.84721 6.51367C9.84721 5.96139 10.2949 5.51367 10.8472 5.51367L18.6934 5.51367C19.2456 5.51367 19.6934 5.96139 19.6934 6.51367Z",
    fill: "#FF7815"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoon);
export default __webpack_public_path__ + "static/media/coming-soon.cf32710620a049daf44d87c795af015f.svg";
export { ForwardRef as ReactComponent };